export default class Certificate {

  public id!: number;

  public number!: string;

  // tslint:disable-next-line:variable-name
  public receipt_in_laboratory_at: any;

  // tslint:disable-next-line:variable-name
  public receipt_in_ano_at: any;

  // tslint:disable-next-line:variable-name
  public entry_type: any;

  // tslint:disable-next-line:variable-name
  public entry_medical_office_id!: number;

  // tslint:disable-next-line:variable-name
  public income_city!: string;

  public count!: number;

  // tslint:disable-next-line:variable-name
  public without_form_count!: number;

  // tslint:disable-next-line:variable-name
  public сt_urgent_comment!: string;

  // tslint:disable-next-line:variable-name
  public biomaterial_sample_id!: number;

  // tslint:disable-next-line:variable-name
  public entry_action_id!: number;

  constructor() {
    this.number = '';
    this.сt_urgent_comment = '';
  }
}
